var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.656 261.656C448.781 258.531 448.781 253.469 445.656 250.344L293.656 98.344C292.094 96.781 290.062 96 288 96S283.906 96.781 282.344 98.344C279.219 101.469 279.219 106.531 282.344 109.656L420.688 248H104C99.594 248 96 251.578 96 256S99.594 264 104 264H420.688L282.344 402.344C279.219 405.469 279.219 410.531 282.344 413.656S290.531 416.781 293.656 413.656L445.656 261.656ZM16 440V72C16 67.582 12.418 64 8 64S0 67.582 0 72V440C0 444.418 3.582 448 8 448S16 444.418 16 440Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFromLine);
export default __webpack_public_path__ + "static/media/arrow-right-from-line.89c8bf1f0d9d00293f557374f880cefb.svg";
export { ForwardRef as ReactComponent };